import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { forEach, isEmpty, sortBy } from 'lodash'

// Base Page 
import BasePage from '@/pages/Base'

//Services
import UserSettingsService from '@/services/UserSettings'

@Component({})
export default class ManageReferral extends BasePage {
  constructor() {
    super()
  }

  // Search
  searchLoading: boolean  = false
  searchInput: string = ''
  searchLabel: string = 'Search By Name...'
  searchHint: string = ''
  searchIcon: string = 'search'

  // Table
  tableHeaders: object[] = [
    {
      text: 'Name',
      align: 'left',
      sortable: false,
      value: 'name'
    },
    {
      text: 'Email',
      align: 'left',
      sortable: false,
      value: 'email'
    },
    {
      text: 'Phone',
      align: 'left',
      sortable: false,
      value: 'phone'
    },
    {
      text: 'Referral Member',
      align: 'center',
      sortable: true,
      value: 'total_childs'
    },
    {
      text: 'Total Transaction Referral Member',
      align: 'center',
      sortable: false,
      value: 'total_referral_order'
    },
    {
      text: 'Credit Balance',
      align: 'right',
      sortable: false,
      value: 'balance'
    },
    {
      text: 'Action',
      align: 'center',
      sortable: false,
      value: 'action',
      class: 'action-table-width'
    }
  ]
  tableItems: object[] = []
  tableTotalItems: string | number = 0
  tableRowsPerPageItems: number[] = [5, 10, 15, 25, 50, 100]
  tablePagination: any = {
    sortBy: 'created_at',
    page: 1,
    rowsPerPage: 10,
    descending: true,
    totalItems: 0
  }
  tableLoading: boolean = false

  @Watch('tablePagination', { deep: true })
  async onChanged() {
    this.$vuetify.goTo(0)
    this.getUsers()
  }

  async onClearSearch() {
    this.searchInput = ''
    await this.getUsers()
  }

  async getUsers () {
    this.tableLoading = true
    const opts: any = {
      params: {
        'page[num]': this.tablePagination.page,
        'page[limit]': this.tablePagination.rowsPerPage,
        'filter[referral_code][null]': false,
        sort: this.tablePagination.descending ? '-' + this.tablePagination.sortBy : this.tablePagination.sortBy,
        include: 'childs'
      }
    }
    if (this.searchInput != '') {
      opts.params = {
        ...opts.params,
        'filter[name][like]': this.searchInput
      }
    } else {
      var textFilter = 'filter[name][like]'
      delete opts.params[textFilter]
    }

    try {
      const response = await UserSettingsService.getUser(opts)
      const responseData = response.data.data
      const responseMeta = response.data.meta

      this.tableItems = []
      forEach(responseData, dataUser => {
        const user = dataUser.attributes
        if (!user.balance) {
          user.balance = 0
        }

        if (!user.phone) {
          user.phone = '-'
        }

        if (!user.email) {
          user.email = '-'
        }

        if (user.country_signup) {
          user.currency = response.data.included.signupcountry[user.country_signup].attributes.currency
        } else {
          user.currency = 'IDR'
        }
        user.referral_member = dataUser.relationships.childs.length

        this.tableItems.push(user)
        this.tableTotalItems = responseMeta.pagination.total
        this.tableLoading = false
      })
    } catch (error) {
      this.catchHandler(error)
    } finally {
      this.tableLoading = false
    }
  }
}